import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Toggle from 'react-toggle';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';


import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';

import PaymentRequestLegs from './PaymentRequestLegs';
import getLocale from '../../i18n/getLocale';

class PaymentRequestScheduleDistanceAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      schedule_grade_id: null,
      staff_id: null,
      payment_batch_id: null,
      destination: null,
      origin: null,
      date_start: '',
      date_finish: '',
      daily_currency: 'BRL',
      training_selected: 0,
      payment_value: 0,
      max_value: 0,
      distance: 0,
      daily_value: 0,
      ignores_debts: 0,
      observation: null,
      bonus: null,
      certification_supplier: null,
      certification_supplier_id: null,
      zipcode_bases: [],
      zipcode_suppliers: [],
      payment_legs: [
        {
          origin_base_id: null,
          origin_supplier_id: null,
          origin_base: null,
          origin_supplier: null,
          zipcode_origin: null,
          destination_base_id: null,
          destination_supplier_id: null,
          destination_base: null,
          destination_supplier: null,
          zipcode_destination: null,
          total: 0,
        }
      ],
      daily_currency_list: [
        {value: "EUR", label: this.locale.general.euro},
        {value: "USD", label: this.locale.general.dolar},
        {value: "BRL", label: this.locale.general.real},
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleChangeLegData = this.handleChangeLegData.bind(this);
    // this.handleChangeDate = this.handleChangeDate.bind(this);

    this.add = this.add.bind(this);
    this.addLeg = this.addLeg.bind(this);
    this.removeLeg = this.removeLeg.bind(this);
    this.resetLeg = this.resetLeg.bind(this);
    this.calculateDistances = this.calculateDistances.bind(this);
    this.loadData = this.loadData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleChangeLegData (name, value, index) {
    var payment_legs = this.state.payment_legs;
    payment_legs[index][name] = value;
    this.setState({payment_legs: payment_legs});
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  // Descontinuado
  // Não atualizamos mais a quantidade de acordo com a quantidade de dias. A quantidade é definida pelo usuário
  // handleChangeDate (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
    
  //   var daily_paid = 0;
  //   var other_date = this.state.date_start;
  //   if(name === 'date_start') {
  //     var other_date = this.state.date_finish;
  //   }
  //   if(change[name].length === 10 && other_date.length === 10) {
  //     date1 = change[name].split('/');
  //     date2 = other_date.split('/');
      
  //     var date1 = new Date(date1[1] + '/' + date1[0] + '/' + date1[2]);
  //     var date2 = new Date(date2[1] + '/' + date2[0] + '/' + date2[2]);
      
  //     // To calculate the time difference of two dates
  //     var Difference_In_Time = date2.getTime() - date1.getTime();
      
  //     // To calculate the no. of days between two dates
  //     daily_paid = Difference_In_Time / (1000 * 3600 * 24);
      
  //     daily_paid =  Math.abs(daily_paid) + 1;
  //   }    
  //   this.setState({daily_paid: daily_paid});
  //   this.handleChangeDailyTotal(this.state.daily_value, daily_paid);
  // }



  handleChangeDaily (name, event) {
    var change = {};
    change[name] = event.target.value;

    this.setState(change);
    this.handleChangeDailyTotal(this.state.daily_value, event.target.value);
  }
  handleChangeDailyPaid (name, event) {
    var change = {};
    change[name] = event.target.value;

    this.setState(change);
    this.handleChangeDailyTotal(this.state.distance, event.target.value);
  }

  handleChangeDailyTotal (daily_value, daily_paid) {
    var daily_paid = daily_paid.toString().replace(',', '.');	
    var daily_value = daily_value.toString().replace(',', '.');
    var total = daily_paid * daily_value;

    this.setState({daily_total: total});
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  TrainingclearSelects() {
    this.setState({training_selected: 0});
    this.setState({distance: ''});
    this.setState({daily_total: ''});
    this.setState({date_start: ''});
    this.setState({date_finish: ''});
    this.setState({training_code: ''});
    this.setState({daily_currency: ''});
    this.setState({certification_supplier_id: ''});
    this.loadData();
  }

  loadData () {
    this.handleAlert('', '', 'open');
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/solicitacao/deslocamento/info';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if(responseJson.status === 'success') {
          let api = 'api';
          self.setState({
            api: api,
            payment_value: responseJson.data.payment_value,
            max_value: responseJson.data.max_value,
            zipcode_bases: responseJson.data.zipcode_bases,
            zipcode_suppliers: responseJson.data.zipcode_suppliers,
          });
          self.setState({schedule_grades_list: responseJson.data.schedule_grades_list});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.setState({overlay: {message: responseJson.message, type: 'error', status: 'open'}});
        }
      }); 
    });
  }

  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      schedule_grade_id: this.state.schedule_grade_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      daily_paid: this.state.daily_paid,
      daily_value: this.state.daily_value,
      daily_total: this.state.daily_total,
      daily_currency: this.state.daily_currency,
      observation: this.state.observation,
      payment_legs: this.state.payment_legs
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get(self.state.api) + '/pagamento/escala/deslocamento/solicitacao/cadastrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/lista/solicitacao/pagamento/deslocamento/missao';
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  resetLeg (type, leg) {
    this.handleChangeLegData((type + '_base_id'), null, leg);
    this.handleChangeLegData((type + '_base'), null, leg);
    this.handleChangeLegData((type + '_supplier_id'), null, leg);
    this.handleChangeLegData((type + '_supplier'), null, leg);
    this.handleChangeLegData(('zipcode_' + type), null, leg);
  }

  calculateDistances () {
    var header = this.refs.request_api.header('application/json');
    var self = this;

    var datasave = this.state.payment_legs;
    
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/calcular/distancia/google';
      fetch(url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var total = (responseJson.data * self.state.payment_value) / 1000;
          if (total > self.state.max_value) {
            total = self.state.max_value;
          }
          self.setState({daily_value: total.toFixed(2)});
          if (self.state.daily_paid) {
            self.handleChangeDailyTotal(total.toFixed(2), self.state.daily_paid);
          }
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      });

    });
  }

  addLeg() {
    var payment_legs = this.state.payment_legs;
    
    payment_legs.push({
      origin_base_id: null,
      origin_supplier_id: null,
      origin_base: null,
      origin_supplier: null,
      zipcode_origin: null,
      destination_base_id: null,
      destination_supplier_id: null,
      destination_base: null,
      destination_supplier: null,
      zipcode_destination: null,
      total: 0,
    });
    this.setState({payment_legs: payment_legs});
  }

  removeLeg(index) {
    var self = this;
    this.state.payment_legs;
    var payment_legs = [];
    Object.keys(this.state.payment_legs).map(function(k) {
      if(k !== index) {
        payment_legs.push({...self.state.payment_legs[k]});
      }
    })
    this.setState({payment_legs: payment_legs});
  }

  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.titulo}</h3>
      <Link to="/lista/solicitacao/pagamento/deslocamento/missao" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.EscalaGrade}:</label>
              <Select
                className="form-field-name"
                name="schedule_grade_id"
                value={this.state.schedule_grade_id}
                searchable={true}
                placeholder={this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.placeholder.SelecionarEscala}
                onChange={this.handleSelectChange.bind(this, 'schedule_grade_id')}
                options={this.state.schedule_grades_list}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
          <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.Quantidade}:</label>
              <input value={this.state.daily_paid} name="daily_paid" className="form-control" onChange={this.handleChangeDaily.bind(this, 'daily_paid')} placeholder="" required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
              <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start} maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder={this.locale.general.diaMesAno} required />
              </div>
          </div>
          <div className="col-md-6">
              <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish} maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder={this.locale.general.diaMesAno} required />
              </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.Valor}:</label>
              <input value={this.state.daily_value} name="daily_value" className="form-control" onChange={this.handleChangeDailyPaid.bind(this, 'daily_value')} placeholder="" disabled required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.Moeda}:</label>
              <Select
                className="form-field-name"
                name="daily_currency"
                value={this.state.daily_currency}
                placeholder={this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.placeholder.SelecionarMoeda}
                onChange={this.handleSelectChange.bind(this, 'daily_currency')}
                options={this.state.daily_currency_list}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.ValorTotal}:</label>
              <input value={this.state.daily_total} name="daily_total" className="form-control" onChange={this.handleChangeDailyTotal.bind(this.state.daily_value, this.state.daily_paid)} placeholder="" disabled required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.Observacao}:</label>
              <input value={this.state.observation} name="observation" className="form-control" onChange={this.handleChange.bind(this, 'observation')} placeholder={this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.placeholder.Observacao} />
            </div>
          </div>
        </div>
        <hr />
        <h4 className="page-title pull-left">{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tituloTrechos}</h4>
        <button type="button" className="btn button-inline btn-warning pull-right" onClick={() => this.addLeg()}><i className="fa fa-plus"></i> {this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.botaoAdicionarTrecho}</button>
        <div className="clearfix"></div>
        <hr />
        <div className="table-responsive">
          <table className="table table-bordered table-stripped table-hover">
            <thead>
              <tr>
                <th className="text-center">#</th>
                <th className="text-center">{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.BuscarLocais}</th>
                <th className="text-center">{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.BaseOrigem}</th>
                <th className="text-center">{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.FornecedorOrigem}</th>
                <th className="text-center">{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.CEPOrigem}</th>
                <th className="text-center">{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.BaseDestino}</th>
                <th className="text-center">{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.FornecedorDestino}</th>
                <th className="text-center">{this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.CEPDestino}</th>
                <th className="text-center"></th>
              </tr>
            </thead>
            <tbody id="suppliers-certifications">
              {Object.keys(this.state.payment_legs).map(function(k) {
                return <PaymentRequestLegs leg_index={k} data={self.state.payment_legs[k]} zipcode_bases={self.state.zipcode_bases} zipcode_suppliers={self.state.zipcode_suppliers} removeLeg={self.removeLeg} handleChangeLegData={self.handleChangeLegData} resetLeg={self.resetLeg} />;
              })}
            </tbody>
          </table>
        </div>
        <div className="row">
          <div className="col-md-12">
          <button type="button" className="btn btn-lg btn-block btn-success pull-right" onClick={() => this.calculateDistances()}><i className="fa fa-check"></i> {this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.botaoCalcular}</button>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.botaoSalvarSolicitacao}</button>
          </div>
        </div>
      </form>
    </div>
  </div>

</div>
    );
  }
}

export default PaymentRequestScheduleDistanceAdd;



// WEBPACK FOOTER //
// ./src/Components/Payments/PaymentRequestScheduleDistanceAdd.js